export default __webpack_public_path__ + "static/media/41.e49b46f8.png";